import React, {useMemo, useState} from "react";
import {ConfigProvider, Tabs} from "antd";
import {PageTitleHeader} from "../../../components/index.jsx";
import {UpsertDeliveryProvider} from "./UpsertDeliveryProvider.jsx";
import {useRequest} from "../../../utils/hooks.jsx";
import {UpdateDeliveryProviderFetchProjection} from "./consts.js";
import {StringBuilder} from "../../../AppUtils.js";
import {DeliveryProviderDrivers} from "./Drivers/DeliveryProviderDrivers.jsx";
import {isEmpty} from "lodash";

export const UploadDeliveryProviderPage = ({match, history}) => {
    const [selectedTab, setSelectedTab] = useState("1");

    const deliveryProviderId = useMemo(() => match?.params?.deliveryProviderId, [match?.params]);

    const [deliveryProvider, error, isLoading, fetchDeliveryProvider] = useRequest(
        `/api/deliveryProvider/info/${deliveryProviderId}`,
        "POST",
        {
            projection: UpdateDeliveryProviderFetchProjection
        },
        [deliveryProviderId],
        !!deliveryProviderId,
        null,
        {}
    );

    const tabOptions = useMemo(
        () => [
            {
                label: "הגדרות ספק",
                key: "1",
                children: (
                    <UpsertDeliveryProvider
                        deliveryProvider={deliveryProvider}
                        history={history}
                        isLoading={isLoading}
                        fetchDeliveryProvider={fetchDeliveryProvider}
                    />
                )
            },
            {
                label: "נהגים",
                key: "2",
                disabled: !deliveryProvider?.deliveryProviderId,
                children: <DeliveryProviderDrivers deliveryProviderId={deliveryProviderId} />
            }
        ],
        [deliveryProvider, history, isLoading, fetchDeliveryProvider, deliveryProviderId]
    );

    const currentTabOption = useMemo(() => tabOptions.find(({key}) => selectedTab === key), [tabOptions, selectedTab]);

    const title = useMemo(() => {
        return isEmpty(deliveryProvider)
            ? "הוספת ספק"
            : new StringBuilder("ספק שילוח", " - ").append(deliveryProvider?.name).toString();
    }, [deliveryProvider]);

    return (
        <div className="admin-upload-page-form">
            <ConfigProvider direction="rtl">
                <PageTitleHeader showBack={false}>{title}</PageTitleHeader>
                <Tabs
                    onChange={key => setSelectedTab(key)}
                    className="provider-form-container"
                    defaultActiveKey="1"
                    items={tabOptions.map(({label, key, disabled}) => ({label, key, disabled}))}
                />
                {!!currentTabOption?.children && currentTabOption.children}
            </ConfigProvider>
        </div>
    );
};
